export default __webpack_public_path__ + "static/media/fincantieri_world_contacts.e25ae9e2.jpeg";